<template>
  <div id="myTasks">
    <el-card
      id="taskCard"
      v-loading="loading"
      shadow="hover"
      class="clear-card"
      :body-style="{padding: '0px'}"
      :class="$mq"
    >
      <div
        slot="header"
        class="clearfix title defaultCursor"
      >
        <span>{{ $t('leader.task.title') }}</span>
      </div>
      <div class="content">
        <div
          v-if="!previewMode && (filteredTasks && filteredTasks.length)
            || (filteredDocuments && filteredDocuments.length)"
        >
          <div
            v-for="(task, key) in filteredTasks"
            :key="`Task${key}`"
            class="task"
            :class="{disabled: currentSession === 1}"
            @click="handleCTA(task.cta)"
          >
            <div
              class="status"
              :class="{completed: task.status === 'completed'}"
            ></div>
            <div class="name">
              {{ $t(`processTasks.${task.description}`) }}
            </div>
          </div>
          <div
            v-if="filteredDocuments && filteredDocuments.length > 0"
          >
            <div
              v-for="(doc, key) in filteredDocuments"
              :key="`Doc${key}`"
              class="task"
              @click="showDocument(doc.key)"
            >
              <div class="documentIcon">
                <i class="el-icon-document"></i>
              </div>
              <div class="name">
                {{ doc.title }}
              </div>
            </div>
          </div>
        </div>

        <div
          v-else-if="currentSession && [1, 2].includes(currentSession)"
          class="no-data defaultCursor"
        >
          {{ $t('leader.task.noTask') }}
        </div>

        <div
          v-else
          class="no-data circle defaultCursor"
        >
          <span>{{ $t('leader.task.noData') }}</span>
        </div>
      </div>
    </el-card>

    <transition
      name="customTransition"
      mode="out-in"
    >
      <ModalDocument
        v-if="modalVisible"
        :show.sync="modalVisible"
        :type="modalType"
      />
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ModalDocument from '../../../leader/myJourney/ModalDocument.vue';
import TaskFilter from './TaskFilter';

export default {
  components: {
    ModalDocument,
  },

  props: {
    previewMode: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      setLga: false,
      modalVisible: false,
      modalType: '',
    };
  },

  computed: {
    ...mapState({
      loading: (state) => state.processStatus.loading,
      // tasks: (state) => state.processStatus.process.sub_tasks.filter((task) => {
      //   if (task.description.startsWith('scheduleSession')) {
      //     return false;
      //   }
      //   return true;
      // }),
      tasks: (state) => state.processStatus.process.sub_tasks.filter((task) => !task.description.startsWith('scheduleSession')),
      currentSession: (state) => state.processStatus.process.session,
      user: (state) => state.user,
      status: (state) => state.processStatus.process,
    }),

    filteredTasks() {
      const tasks = [];

      if (TaskFilter.sessions && this.currentSession !== null && this.tasks) {
        let request = TaskFilter.sessions[`session_${this.currentSession}`];

        // If session task behaviour differently by meeting time
        if ([2, 3].includes(this.currentSession)) {
          request = this.status.meeting_status === 'completed'
            ? TaskFilter.sessions[`after_${this.currentSession}`]
            : TaskFilter.sessions[`session_${this.currentSession}`];
        }

        // If Task description included Requested filter
        this.tasks.forEach((item) => {
          if (request.includes(item.description)) {
            tasks.push(item);
          }
        });
      }

      return tasks;
    },

    filteredDocuments() {
      const docs = [];
      let request = [];

      if (this.status.meeting_status !== 'completed') {
        if (TaskFilter.documents[`document_${this.currentSession}`]
          && this.currentSession !== null) {
          request = TaskFilter.documents[`document_${this.currentSession}`];
        }
      } else if (TaskFilter.documents[`document_after_${this.currentSession}`]
        && this.currentSession !== null) {
        request = TaskFilter.documents[`document_after_${this.currentSession}`];
      }

      request.forEach((doc) => {
        docs.push(doc);
      });

      return docs;
    },
  },

  methods: {
    handleCTA(action) {
      const actionFormat = action.split(':');

      if (actionFormat[0] === 'route') {
        this.$router.push({ name: actionFormat[1] }).catch((err) => {});
      }

      if (actionFormat[0] === 'modal') {
        if (actionFormat[1] === 'lga') {
          this.setLga = true;
        }
      }

      if (actionFormat[0] === 'pulseSurvey') {
        this.$router.push({
          name: 'pulse',
        });
      }
    },

    showDocument(key) {
      this.modalType = key;
      this.modalVisible = true;
      // this.$router.push({
      //   name: 'myJourney',
      //   query: { key },
      // })
      //   .catch((err) => {
      //     console.log(err);
      //   });
    },
  },
};
</script>

<style lang="scss" scoped>
  #myTasks {
    height: 100%;

    .title {
      text-align: center;
    }

    #taskCard {
      height: 100%;

      &:not(.mobile):not(.tablet) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }

      .el-card__header {
        font-weight: bold;
      }

      &.mobile,
      &.tablet {
        .el-card__header {
          border-bottom: 0;
        }
      }

      .content {
        text-align: left;

        .task {
          display: flex;
          padding: 15px 20px;
          align-items: center;

          .documentIcon {
            padding-right: 6px;
          }

          .status {
            min-width: 12px;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            margin-right: 10px;
            background: #c4c4c4;

            &.completed {
              background: #66d73f;
            }
          }

          &:not(.disabled):hover {
            background-color: rgba(255, 255, 255, 0.2);
            cursor: pointer;
          }

          &.disabled {
            color: #ffffff6b;

            &:hover {
              cursor: not-allowed;
            }
          }
        }

        .no-data {
          display: flex;
          width: 100%;
          height: 100px;
          padding: 20px;
          box-sizing: border-box;
          justify-content: center;
          align-items: center;
          font-style: italic;
          color: #dcdcdc;
          text-align: center;
        }
      }
    }
  }
</style>

<style lang="scss">
  #myTasks {
    #taskCard {
      .el-card__header {
        font-weight: bold;
      }

      &.mobile,
      &.tablet {
        .el-card__header {
          border-bottom: 0;
        }
      }
    }
  }
</style>
